import * as React from "react";
import {
  Box,
  Typography,
  Stack,
  Paper,
  Snackbar,
  Alert,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { useI18n } from "../../i18n/I18nProvider";
import { useWorkshopBlocker, FLOW } from "../../logic/useWorkshopBlocker";


export default function ShareStateScreen(props: {handlePageChange: (p: string) => void}) {
  const { handlePageChange } = props;
  const blocker = useWorkshopBlocker();
  const { lang } = useI18n();
  const isDE = lang === "de";
  const [notice, setNotice] = React.useState<string | null>(null);

  const myIndex = FLOW.indexOf("ShareStateScreen");
  const blockerIndex = FLOW.indexOf(blocker);
  const canContinue = blockerIndex > myIndex;
  
  function handleContinue() {
    if (canContinue) {
      handlePageChange(FLOW[myIndex + 1]);
      return;
    }
    setNotice("ENG / DE");
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        px: 2,
        py: { xs: 3, sm: 5 },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#111010",
      }}
    >
      <Paper
        sx={{
          width: "min(900px, 100%)",
          maxWidth: 900,
          p: { xs: 2.5, sm: 4, md: 5 },
          borderRadius: { xs: 3, sm: 5 },
          background: "linear-gradient(180deg, #311f1f, #221515)",
        }}
      >
        <Stack spacing={{ xs: 3.5, sm: 5 }} alignItems="center">

          {/* TITLE */}
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 800,
              fontSize: { xs: "1.4rem", sm: "1.65rem", md: "1.8rem" },
              textAlign: "center",
            }}
          >
            {isDE ? "DEIN STATUS" : "YOUR STATUS"}
          </Typography>

          {/* STATUS BLOCKS */}
          <Stack spacing={3} sx={{ width: "100%" }}>

            {/* AWARE */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 2,
                borderRadius: 2,
                background: "rgba(76,175,80,0.1)",
                border: "1px solid #4caf50",
              }}
            >
              <CheckCircleIcon sx={{ color: "#4caf50" }} />
              <Typography sx={{ color: "#fff", fontWeight: 700 }}>
                {isDE ? "BEWUSST." : "AWARE."}
              </Typography>
            </Box>

            {/* PREPARED */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 2,
                borderRadius: 2,
                background: "rgba(76,175,80,0.1)",
                border: "1px solid #4caf50",
              }}
            >
              <CheckCircleIcon sx={{ color: "#4caf50" }} />
              <Typography sx={{ color: "#fff", fontWeight: 700 }}>
                {isDE ? "BEREIT." : "PREPARED."}
              </Typography>
            </Box>

            {/* COMMUNITY */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 2,
                borderRadius: 2,
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArrowCircleRightIcon sx={{ color: "#ff8a8a" }} />
              <Typography sx={{ color: "#ff8a8a", fontWeight: 800 }}>
                {isDE ? "GEMEINSAM?" : "SHARE?"}
              </Typography>
            </Box>

          </Stack>

          {/* OPTIONAL SUBTEXT */}
          <Typography
            sx={{
              color: "#aaa",
              textAlign: "center",
              maxWidth: 600,
            }}
          >
            {isDE
              ? "Resilienz endet nicht bei dir. Sie entsteht im Zusammenspiel mit anderen."
              : "Resilience does not end with you. It emerges through connection with others."}
          </Typography>

            <Button
              variant="contained"
              onClick={handleContinue}
              sx={{
                mt: 1,
                borderRadius: 999,
                textTransform: "none",
                fontWeight: 800,
                px: 3,
                bgcolor: canContinue ? "#ffffff" : "rgba(255,255,255,0.35)",
                color: canContinue ? "#111827" : "rgba(255,255,255,0.8)",
                "&:hover": {
                  bgcolor: canContinue ? "#f3f4f6" : "rgba(255,255,255,0.35)",
                },
              }}
            >
              {isDE ? "Weiter" : "Continue"}
            </Button>
        </Stack>
      </Paper>
      <Snackbar
        open={Boolean(notice)}
        autoHideDuration={5000}
        onClose={() => setNotice(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={() => setNotice(null)} severity="info" sx={{ width: "100%", fontWeight: 700 }}>
          {isDE ? "Die Workshop-Leitung wird diesen Schritt freigeben, oder bitte beantworte die Frage vollständig und sende sie zuerst ab." : "The workshop holder will enable this step, or please complete and submit your answer first."}
        </Alert>
      </Snackbar>
    </Box>
  );
}